import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { DataInitializer } from "./state-management/DataInitializer"
import { domMax, LazyMotion } from "framer-motion"

import "./index.css"
import { ProfileInitializer } from "./state-management/ProfileInitializer"
import { LanguageInitializer } from "./state-management/LanguageInitializer"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <ProfileInitializer>
        <LanguageInitializer>
            <DataInitializer>
                <LazyMotion features={domMax}>
                    <App />
                </LazyMotion>
            </DataInitializer>
        </LanguageInitializer>
    </ProfileInitializer>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log)
